import { Button } from '@connected/ui/components/button';
import { ButtonGroup } from '@connected/ui/components/button-group';

import { ValidationErrorsModal } from '@/components/features/validation-errors';

import { useCreateReport } from '../hooks/use-create-report';
import { ReportKindDropdown } from './report-kind-dropdown';

export type CreateReportButtonProps = {
    electricalProjectVersionId: string;
};

export function CreateReportButton({ electricalProjectVersionId }: CreateReportButtonProps) {
    const {
        handleDocumentCreation,
        isCreating,
        isOffline,
        validationModalOpen,
        handleOpenChange,
        validationItems,
        buttonLabel,
        isCombinationInspection,
        enabledKinds,
        toggleKind,
        forceCreate,
    } = useCreateReport({ electricalProjectVersionId });

    const allKinds = Array.from(enabledKinds);

    return (
        <>
            {isCombinationInspection
                ? (
                    <ButtonGroup>
                        <Button
                            onClick={handleDocumentCreation}
                            disabled={isCreating || isOffline || enabledKinds.size === 0}
                        >
                            {buttonLabel}
                        </Button>
                        <ButtonGroup.Separator />
                        <ReportKindDropdown
                            enabledKinds={enabledKinds}
                            onToggle={toggleKind}
                            allKinds={allKinds}
                            disabled={isCreating || isOffline}
                        />
                    </ButtonGroup>
                )
                : (
                    <Button
                        onClick={handleDocumentCreation}
                        disabled={isCreating || isOffline}
                    >
                        {buttonLabel}
                    </Button>
                )}
            <ValidationErrorsModal
                open={validationModalOpen}
                onOpenChange={handleOpenChange}
                validationItems={validationItems}
                onForceCreate={forceCreate}
                isCreating={isCreating}
                isOffline={isOffline}
            />
        </>
    );
}
